import { Component, inject, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Match } from '../../_shared/models/match.model';
import { Tie } from '../../_shared/models/tie.model';
import { ThemeService } from '../../_core/services/theme.service';
import { CommonModule } from '@angular/common';
import { IntMatchScoreComponent } from '../int-match-score/int-match-score.component';
import { IntBodyComponent } from '../int-body/int-body.component';


@Component({
  selector: 'app-score-summary',
  templateUrl: './score-summary.component.html',
  styleUrls: ['./score-summary.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    IntMatchScoreComponent,
    IntBodyComponent,
  ],
})
export class ScoreSummaryComponent  implements OnInit {
  private modalController = inject(ModalController);
  public themeService = inject(ThemeService);
  @Input() match: Match;
  @Input() tie: Tie;
  @Input() matchTotalScore: any;
  @Input() matchCollectionName: any;

  constructor() { }

  ngOnInit() { }

  dismiss(action = null) {
    this.modalController.dismiss(action);
  }

}
